import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./utils";
import {
  QuestionnaireSectionsForNavigation,
  QuestionGroupWithRelations,
  RestrictedQuestionOptionVisibility,
  QuestionnaireSectionWithStatus,
} from "../../../api/src/types";

export const questionnaireApi = createApi({
  reducerPath: "questionnaireApi",
  baseQuery,
  tagTypes: [
    "QuestionnaireSections",
    "QuestionGroup",
    "QuestionOptionVisibility",
  ],
  endpoints: (builder) => ({
    getQuestionnaireSections: builder.query<
      QuestionnaireSectionsForNavigation[],
      { id: string; includeStatus: boolean }
    >({
      query: ({ id, includeStatus }) => ({
        url: `users/${id}/questionnaire-sections?includeStatus=${includeStatus}`,
        method: "GET",
      }),
      providesTags: ["QuestionnaireSections"],
    }),
    getQuestionnaireSectionDetails: builder.query<
      QuestionnaireSectionWithStatus,
      { id: string; section: string }
    >({
      query: ({ id, section }) => ({
        url: `users/${id}/questionnaire-sections/${section}`,
        method: "GET",
      }),
      providesTags: ["QuestionnaireSections"],
    }),
    getQuestionnaireSectionGroupsByUserId: builder.query<
      QuestionGroupWithRelations[],
      { id: string; section: string }
    >({
      query: ({ id, section }) => ({
        url: `users/${id}/questionnaire-sections/${section}/groups`,
        method: "GET",
      }),
      providesTags: ["QuestionGroup"],
    }),
    getQuestionnaireSectionGroupsByDocumentId: builder.query<
      QuestionGroupWithRelations[],
      { docId: string; section: string }
    >({
      query: ({ docId, section }) => ({
        url: `documents/${docId}/questionnaire-sections/${section}/groups`,
        method: "GET",
      }),
      providesTags: ["QuestionGroup"],
    }),
    getQuestionOptionVisibility: builder.query<
      RestrictedQuestionOptionVisibility,
      { restrictedQuestionOptionIds: string[]; userId: string }
    >({
      query: ({ restrictedQuestionOptionIds, userId }) => ({
        url: `users/${userId}/question-options`,
        method: "POST",
        body: { restrictedQuestionOptionIds },
      }),
      providesTags: ["QuestionOptionVisibility"],
    }),
  }),
});

export const {
  useGetQuestionnaireSectionsQuery,
  useGetQuestionnaireSectionDetailsQuery,
  useGetQuestionnaireSectionGroupsByUserIdQuery,
  useGetQuestionnaireSectionGroupsByDocumentIdQuery,
  useGetQuestionOptionVisibilityQuery,
} = questionnaireApi;
